<template>
  <div class="product-header pl-4 pr-4 pt-2 pb-2 mb-3">
    <h4 class="m-0">
      <slot name="icon"> </slot>
      <strong><slot name="title"></slot></strong>
    </h4>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
div.product-header {
  background-color: $dp-light-blue;
  text-transform: uppercase;
  .icon {
    margin-top: -0.18rem;
  }
}
</style>
